export const GRAPH_MARKET_ANALYSIS_QUERY = `
query resiPdp_listingMarketingAnalysis($dsl: String) {
  seek(type: LISTINGS, dsl: $dsl) {
    content {
      ... on Listing {
        listing_configuration {
          is_rental_estimate_hidden
        }
        external_information(resolvePolicy: ORIGIN_ONLY) {
          is_property_report_hidden

          collateral {
            summary {
              low
              high
              estimated
              type
            }

            comparables {
              propertylistArray {
                property {
                  distance
                  source
                  type
                  info {
                    soldprice
                    solddate
                    bedrooms
                    bathrooms
                    livingarea
                    rentprice
                    rentdate
                    landarea
                    yearbuilt
                    geocode {
                      latitude
                      longitude
                    }
                  }
                  address {
                    fulladdress
                  }
                }
                source
              }
            }

            neighborhoodview {
              communityfeatures {
                distance
                feature
              }

              areaanalysis {
                location
                mediansoldprice
                valuetrend
                medianage
                owneroccupancyratio
                rentaloccupancyratio
                neighborhoodpricerange {
                  low
                  high
                }
                rentalrange {
                  low
                  high
                }
              }
            }

            neighboorhodreports {
              publicschools {
                school {
                  schoolname
                  gradespan {
                    low
                    high
                  }
                  distancefromsubj
                  totalenrolled
                  studentteacherratio
                  additionalinfo {
                    value2
                  }
                }
              }
            }

            property {
              historicaltransactions {
                type
                amount
                date
                datasource
              }
              info {
                landvalue
                assessedyear
                taxyear
                improvementvalue
                taxvalue
                assessedvalue
                taxexemption
                delinquenttaxyear
              }
            }
          }
        }
      }
    }
  }
}
`
